var OidcSettings = {
    authority: process.env.REACT_APP_GLOBAL_AUTHORIZATION_CODE,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri:process.env.REACT_APP_CLIENTROOT,
    response_type: process.env.REACT_APP_RESPONSETYPE,
    scope: process.env.REACT_APP_CLIENTSCOPE,
    post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL
  };
  
  export default OidcSettings;